import { Stack, router } from 'expo-router';
import * as React from 'react';
import { ScrollView, View } from 'react-native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';

import { Button } from '@sixam/ui/button';
import { Text } from '@sixam/ui/text';
import { COMMUNITY_TERMS, TERMS_SUMMARY } from '@sixam/shared/community-terms';

/**
 * The full community terms, reachable without an account so they can be read
 * before agreeing — which is the order App Review checks.
 */
export default function TermsScreen() {
  const insets = useSafeAreaInsets();

  return (
    <View className="flex-1 bg-background">
      <Stack.Screen options={{ headerShown: false }} />
      <ScrollView
        contentContainerStyle={{
          paddingBottom: insets.bottom + 32,
          paddingHorizontal: 20,
          paddingTop: 24,
        }}
      >
        <View className="mx-auto w-full max-w-3xl gap-6">
          <View className="gap-2">
            <Text variant="h2">Community terms</Text>
            <Text variant="muted">{TERMS_SUMMARY}</Text>
          </View>

          {COMMUNITY_TERMS.map((section) => (
            <View className="gap-2" key={section.title}>
              <Text variant="large">{section.title}</Text>
              {section.body.map((paragraph) => (
                <Text key={paragraph} selectable>
                  {paragraph}
                </Text>
              ))}
            </View>
          ))}

          <Button onPress={() => router.back()} variant="secondary">
            <Text>Close</Text>
          </Button>
        </View>
      </ScrollView>
    </View>
  );
}
